import { render } from "./FranchiseBenefits.vue?vue&type=template&id=6eadc480&scoped=true&ts=true"
import script from "./FranchiseBenefits.vue?vue&type=script&lang=ts"
export * from "./FranchiseBenefits.vue?vue&type=script&lang=ts"

import "./FranchiseBenefits.vue?vue&type=style&index=0&id=6eadc480&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eadc480"]])

export default __exports__